module.exports = __webpack_public_path__ + "static/Rajat-Khare-05fcd3f45cd563d774912e062de01977.png";